export function convertValuesToInput(values) {
  const result = {};

  Object.keys(values).forEach((key) => {
    const value = values[key];
    if (key !== "__typename") {
      if (Array.isArray(value)) {
        result[key] = value.map((item) => {
          return item.id ? { id: item.id } : item;
        });
      } else if (value instanceof Object) {
        result[key] = value.id ? { id: value.id } : value;
      } else {
        result[key] = value;
      }
    }
  });

  return result;
}
